export default "__VITE_ASSET__C818Zsgp__"